import React, { type ReactNode } from 'react';

import { Stack, Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import type { Size as SpinnerSize } from '@atlaskit/spinner/types';

export const LoadingContent = ({
	loadingText,
	spinnerSize,
}: {
	loadingText: ReactNode;
	spinnerSize: SpinnerSize;
}): React.JSX.Element => (
	<Stack space="space.400" alignInline="center">
		{/* Doesn't need a label because the text below it is present. No label === presentational */}
		<Spinner size={spinnerSize} label="" />
		<Text color="color.text.subtle">{loadingText}</Text>
	</Stack>
);
